"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwOrderedList = _interopRequireDefault(require("../../components/cworderedlist/CwOrderedList"));

var _CwButton = _interopRequireDefault(require("../../components/cwbutton/CwButton"));

var _CwDoubleOrderedList = _interopRequireDefault(require("./CwDoubleOrderedList.scss"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var CwDoubleOrderedList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwDoubleOrderedList, _React$Component);

  function CwDoubleOrderedList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDoubleOrderedList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDoubleOrderedList).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLeftChanged", function (leftItems) {
      _this.setState({
        leftItems: leftItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRightChanged", function (rightItems) {
      _this.setState({
        rightItems: rightItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLeftFocus", function () {
      var rightItems = (0, _toConsumableArray2.default)(_this.state.rightItems);
      rightItems.forEach(function (x) {
        return x.selected = false;
      });

      _this.setState({
        rightItems: rightItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRightFocus", function () {
      var leftItems = (0, _toConsumableArray2.default)(_this.state.leftItems);
      leftItems.forEach(function (x) {
        return x.selected = false;
      });

      _this.setState({
        leftItems: leftItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveAllLeft", function () {
      var items = _this.state.rightItems.filter(function (x) {
        return !x.locked;
      });

      _this.moveLeft(items);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveAllRight", function () {
      var items = _this.state.leftItems.filter(function (x) {
        return !x.locked;
      });

      _this.moveRight(items);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveLeft", function () {
      var selected = _this.getSelectedRight();

      _this.moveLeft(selected);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveRight", function () {
      var selected = _this.getSelectedLeft();

      _this.moveRight(selected);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "moveLeft", function (items) {
      var leftItems = (0, _toConsumableArray2.default)(_this.state.leftItems).concat(items);

      var rightItems = _this.state.rightItems.filter(function (x) {
        return !items.find(function (i) {
          return i.id === x.id;
        });
      });

      _this.setState({
        leftItems: leftItems,
        rightItems: rightItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "moveRight", function (items) {
      var rightItems = (0, _toConsumableArray2.default)(_this.state.rightItems).concat(items);

      var leftItems = _this.state.leftItems.filter(function (x) {
        return !items.find(function (i) {
          return i.id === x.id;
        });
      });

      _this.setState({
        leftItems: leftItems,
        rightItems: rightItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedLeft", function () {
      return _this.state.leftItems.filter(function (x) {
        return x.selected;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedRight", function () {
      return _this.state.rightItems.filter(function (x) {
        return x.selected;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveUp", function () {
      _this.reorderItems(true);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveDown", function () {
      _this.reorderItems(false);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "reorderItems", function (up) {
      var move = up ? _this.moveUp : _this.moveDown;
      var leftItems = move((0, _toConsumableArray2.default)(_this.state.leftItems), _this.getSelectedLeft());
      var rightItems = move((0, _toConsumableArray2.default)(_this.state.rightItems), _this.getSelectedRight());

      _this.setState({
        leftItems: leftItems,
        rightItems: rightItems
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "moveUp", function (array, selected) {
      selected.forEach(function (item) {
        var index = array.indexOf(item);

        if (index > 0) {
          array.splice(index, 1);
          array.splice(index - 1, 0, item);
        }
      });
      return array;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "moveDown", function (array, selected) {
      selected.reverse().forEach(function (item) {
        var index = array.indexOf(item);

        if (index < array.length - 1) {
          array.splice(index, 1);
          array.splice(index + 1, 0, item);
        }
      });
      return array;
    });
    _this.state = {
      leftItems: [],
      rightItems: []
    };
    return _this;
  }

  (0, _createClass2.default)(CwDoubleOrderedList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rightItems = [],
          leftItems = [];
      var _this$props = this.props,
          value = _this$props.value,
          items = _this$props.items;
      value.forEach(function (id) {
        rightItems.push(items.find(function (x) {
          return x.id === id;
        }));
      });
      leftItems = items.filter(function (x) {
        return !value.includes(x.id);
      });
      this.setState({
        leftItems: leftItems,
        rightItems: rightItems
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.rightItems !== prevState.rightItems) {
        var value = [];
        this.state.rightItems.forEach(function (x) {
          return value.push(x.id);
        });

        if (this.props.onChange) {
          this.props.onChange(value);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var groupName = "cw-ordered-list" + (props.cwId ? props.cwId : "");
      var leftItems = this.getSelectedLeft();
      var rightItems = this.getSelectedRight();
      var hasLeftItems = leftItems.length > 0;
      var hasRightItems = rightItems.length > 0;
      var leftDisabled = props.disabled || !hasRightItems || rightItems.find(function (x) {
        return x.locked;
      });
      var rightDisabled = props.disabled || !hasLeftItems || leftItems.find(function (x) {
        return x.locked;
      });
      var reorderDisabled = props.disabled || !hasLeftItems && !hasRightItems;
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwDoubleOrderedList.default.wrap
      }, _react.default.createElement(_CwOrderedList.default, {
        listHeader: props.leftListLabel,
        options: this.state.leftItems,
        onChange: this.onLeftChanged,
        onFocus: this.onLeftFocus,
        groupName: groupName,
        disabled: props.disabled
      }), _react.default.createElement("div", {
        className: _CwDoubleOrderedList.default.buttons
      }, _react.default.createElement(_CwButton.default, {
        icon: _IconPath.default.get('Action_Forward'),
        onClick: this.onMoveRight,
        disabled: rightDisabled
      }), _react.default.createElement(_CwButton.default, {
        icon: _IconPath.default.get('Action_Back'),
        onClick: this.onMoveLeft,
        disabled: leftDisabled
      }), this.props.hasReorderButtons ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_CwButton.default, {
        icon: _IconPath.default.get('Action_Collapse'),
        onClick: this.onMoveUp,
        disabled: reorderDisabled
      }), _react.default.createElement(_CwButton.default, {
        icon: _IconPath.default.get('Action_Expand'),
        onClick: this.onMoveDown,
        disabled: reorderDisabled
      })) : null, this.props.hasMoveAllButtons ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_CwButton.default, {
        icon: _IconPath.default.get('Action_Add_All'),
        onClick: this.onMoveAllRight
      }), _react.default.createElement(_CwButton.default, {
        icon: _IconPath.default.get('Action_Remove_All'),
        onClick: this.onMoveAllLeft
      })) : null), _react.default.createElement(_CwOrderedList.default, {
        listHeader: props.rightListLabel,
        options: this.state.rightItems,
        onChange: this.onRightChanged,
        onFocus: this.onRightFocus,
        groupName: groupName,
        disabled: props.disabled
      }));
    }
  }]);
  return CwDoubleOrderedList;
}(_react.default.Component);

CwDoubleOrderedList.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes.default.func,

  /**
   * List of all items
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    name: _propTypes.default.string.isRequired,

    /**
     * If true, indicates that the item cannot be moved left/right
     */
    locked: _propTypes.default.bool
  })).isRequired,

  /**
   * List of selected item ids
   */
  value: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /**
   * Label for the left list box
   */
  leftListLabel: _propTypes.default.string,

  /**
   * Label for the right list box
   */
  rightListLabel: _propTypes.default.string,

  /**
   * Used to disable the entire widget (lists, filters and buttons)
   */
  disabled: _propTypes.default.bool,

  /**
   * Indicates whether the component should include buttons to move the selected item up/down
   */
  hasReorderButtons: _propTypes.default.bool,

  /**
   * Indicates whether the component should include buttons to move all items to the included/excluded lists
   */
  hasMoveAllButtons: _propTypes.default.bool
};
CwDoubleOrderedList.defaultProps = {
  items: [],
  value: [],
  hasReorderButtons: true
};
var _default = CwDoubleOrderedList;
exports.default = _default;